<app-topbar></app-topbar>
<div class="content-container">
  <app-navbar></app-navbar>
  <div class="container-fluid">
    <h2 class="my-3">Revisión de datos inconsistentes</h2>
    <div class="form-group col-lg-6 col-xs-12">
      <select
        id="selectPersonaIncongruente"
        class="form-control"
        (change)="onSelectPersonaIncongruente($event)"
      >
        <option value="">-- Selecciona una persona --</option>
        <option
          *ngFor="let personaIncongruente of listaPersonasIncongruentes"
          [value]="personaIncongruente.cuil"
        >
          {{ personaIncongruente.nombre }} {{ personaIncongruente.apellido }}
          {{ personaIncongruente.cuil }}
        </option>
      </select>
    </div>
    <div class="mb-3" *ngIf="mostrarTabla">
      <button
        class="btn btn-secondary btn-sm me-2 mt-4"
        (click)="deseleccionarTodo()"
      >
        Deseleccionar todo
      </button>
      <button
        class="btn btn-success me-2 btn-sm float-end mt-4"
        (click)="crearNuevaPersonaDto()"
      >
        Resolver inconsistencias
      </button>
    </div>
    <div class="table-responsive mt-4 mb-4" [hidden]="!mostrarTabla">
      <table
        id="personaComparacionTable"
        class="table table-striped table-bordered"
      >
        <thead>
          <tr>
            <th style="width: 20%"></th>
            <th class="datos-actuales" style="width: 40%">
              <button
                class="btn btn-primary btn-sm float-start me-2"
                (click)="seleccionarTodo('persona')"
              >
                Seleccionar todo
              </button>
              Datos actuales
            </th>
            <th class="datos-importados" style="width: 40%">
              <button
                class="btn btn-primary btn-sm float-start me-2"
                (click)="seleccionarTodo('personaIncongruente')"
              >
                Seleccionar todo
              </button>
              Datos importados
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let campo of campos">
            <td style="font-weight: bold">{{ campo.nombreTabla }}</td>
            <td class="datos-actuales">
              <input
                type="checkbox"
                [checked]="
                  seleccion['persona_' + campo.nombre] === persona[campo.nombre]
                "
                (change)="
                  onSelect(campo.nombre, 'persona', persona[campo.nombre])
                "
              />
              {{ getCampoDescripcion(persona, campo.nombre) }}
            </td>
            <td class="datos-importados">
              <input
                type="checkbox"
                [checked]="
                  seleccion['personaIncongruente_' + campo.nombre] ===
                  personaIncongruente[campo.nombre]
                "
                (change)="
                  onSelect(
                    campo.nombre,
                    'personaIncongruente',
                    personaIncongruente[campo.nombre]
                  )
                "
              />
              {{ getCampoDescripcion(personaIncongruente, campo.nombre) }}
            </td>
          </tr>
        </tbody>
      </table>
      <button
        class="btn btn-secondary btn-sm me-2 mt-2"
        (click)="deseleccionarTodo()"
      >
        Deseleccionar todo
      </button>
      <button
        class="btn btn-success me-2 btn-sm float-end mt-2"
        (click)="crearNuevaPersonaDto()"
      >
        Resolver inconsistencias
      </button>
    </div>
  </div>
</div>
